import trans from '../utils/trans';

/**
 * Translation method plugin
 */
export default {
  install(Vue) {
    Vue.prototype.$trans = trans;
  },
};
